'use client';

import { usePathname, useRouter } from 'next/navigation';
import Chevronleft from '@fluentui/svg-icons/icons/chevron_left_20_regular.svg';
import Chevronright from '@fluentui/svg-icons/icons/chevron_right_20_regular.svg';
import { useLocale } from 'next-intl';

export default function BackButton({ previousRout }: { previousRout: string }) {
  const locale = useLocale();
  const router = useRouter();

  const goBack = () => {
    router.push(previousRout);
  };

  return (
    <button
      onClick={goBack}
      className={`absolute top-4 flex cursor-pointer flex-col md:top-[56px] ${
        locale === 'en'
          ? 'left-4 pl-4 pr-6 md:left-[56px]'
          : 'right-4 pl-6 pr-4 md:right-[56px]'
      } h-10 items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white py-2 shadow-sm`}
    >
      <p className="flex items-center gap-2">
        {locale === 'en' ? (
          <>
            <Chevronleft className="fill-current text-gray-500" /> Back
          </>
        ) : (
          <>
            <Chevronright className="fill-current text-gray-500" />{' '}
            <span className="mb-2">رجوع</span>
          </>
        )}
      </p>
    </button>
  );
}
